import { useMemo } from 'react';

export const useIds = (itemsWithIds: { id: number }[]) =>
  useMemo(() => itemsWithIds.map(({ id }) => id), [itemsWithIds]);
